module.exports = __webpack_public_path__ + "img/RADS.e8e8a7d8.svg";